import apiTestimony from '@/api/vo/testimony';

const defaultState = () => ({
	responseSuccess: {},
});

const state = defaultState();

const getters = {};

const mutations = {
	setSuccessTransaction(state, data) {
		state.responseSuccess = data.data
	},
};

const actions = {

	addTestimony({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiTestimony.addTestimony(value).then( res => {
				const data = res.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(err => {
				const data = err.response.data.data
				commit("saveConfirmResponse", data);
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Gagal Trabsaksi Produk'
				}, { root: true });
				reject()
			});
		});
	},
	
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	
	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};